import { type SelectOption } from '../../../../../components';
import { OTHER_TEST_TYPE } from '../constants';
import { PAGE_TEXT } from '../lang';

const {
  QUALIFICATION: { OTHER_TEST },
} = PAGE_TEXT;

export const otherTestTypeOptions: SelectOption[] = [
  {
    value: OTHER_TEST_TYPE.GMAT_FOCUS,
    label: OTHER_TEST.OPTIONS_LABEL.OTHER_TEST_TYPE.GMAT_FOCUS,
  },
  {
    value: OTHER_TEST_TYPE.GMAT_ONLINE,
    label: OTHER_TEST.OPTIONS_LABEL.OTHER_TEST_TYPE.GMAT_ONLINE,
  },
  {
    value: OTHER_TEST_TYPE.GMAT,
    label: OTHER_TEST.OPTIONS_LABEL.OTHER_TEST_TYPE.GMAT,
  },
  {
    value: OTHER_TEST_TYPE.GRE,
    label: OTHER_TEST.OPTIONS_LABEL.OTHER_TEST_TYPE.GRE,
  },
];
